import styled from 'styled-components';

const StyledSection = styled.section`
  width: 100%;
  margin-bottom: 100px;
`;

export default StyledSection;
